/* Men's advertorial LP behavior + analytics.
 *
 * Reuses the EXISTING Meta Pixel and GA4 — never instantiates either. Every
 * call is guarded (typeof fbq/gtag === 'function'); if the pixel is a sandboxed
 * Shopify Web Pixel, window.fbq won't exist here and fbq calls no-op cleanly.
 * GA4 / dataLayer events mirror everything and are the reliable lander signal.
 *
 * Does NOT touch the Purchase event or checkout wiring — that code is frozen.
 * Config for ViewContent is read from #mns-analytics-config; everything else is
 * read from data-attributes on [data-mns-buybox]. All listeners fail closed.
 */
(function () {
  'use strict';

  var cfg = {
    lpName: 'mens_advertorial',
    category: 'advertorial_lp',
    contentIds: [],
    contentType: 'product',
    currency: 'USD',
    viewContentValue: 0
  };
  try {
    var node = document.getElementById('mns-analytics-config');
    if (node) { cfg = Object.assign(cfg, JSON.parse(node.textContent || '{}')); }
  } catch (e) { /* swallow */ }

  /* ---- Emitters -------------------------------------------------------- */
  function ga(name, params) {
    try {
      if (typeof gtag === 'function') {
        gtag('event', name, Object.assign({ event_category: cfg.category, lp_name: cfg.lpName }, params || {}));
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push(Object.assign({ event: name, event_category: cfg.category, lp_name: cfg.lpName }, params || {}));
      }
    } catch (e) { /* swallow */ }
  }
  function fb(event, params) {
    try {
      if (typeof window.fbq === 'function') { window.fbq('track', event, params || {}); }
    } catch (e) { /* swallow */ }
  }
  function slug(s) { return String(s || 'unknown').replace(/[^a-z0-9]+/gi, '_').toLowerCase(); }
  function getUtms() {
    var out = {};
    try {
      var p = new URLSearchParams(window.location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        var v = p.get(k);
        if (v) out[k] = v.slice(0, 100);
      });
    } catch (e) { /* swallow */ }
    return out;
  }

  function init() {
    /* 1. Page view + ViewContent --------------------------------------- */
    ga('lp_view', Object.assign({ event_label: cfg.lpName }, getUtms()));
    fb('ViewContent', { content_ids: cfg.contentIds, content_type: cfg.contentType, value: cfg.viewContentValue, currency: cfg.currency });
    ga('view_content', { event_label: cfg.lpName, currency: cfg.currency, value: cfg.viewContentValue });

    /* 2. Scroll depth 25/50/75/100 ------------------------------------- */
    var depthFired = { 25: false, 50: false, 75: false, 100: false };
    var thresholds = [25, 50, 75, 100];
    var scheduled = false;
    function onScroll() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        var doc = document.documentElement;
        var scrollable = Math.max(1, (doc.scrollHeight || 0) - (window.innerHeight || 0));
        var pct = ((window.scrollY || window.pageYOffset || 0) / scrollable) * 100;
        for (var i = 0; i < thresholds.length; i++) {
          var t = thresholds[i];
          if (!depthFired[t] && pct >= t) {
            depthFired[t] = true;
            ga('scroll_depth_' + t, { event_label: String(t), depth_pct: t });
          }
        }
        if (depthFired[100]) { window.removeEventListener('scroll', onScroll); }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    /* 3. Reading progress bar ------------------------------------------ */
    var progressFill = document.querySelector('[data-mns-progress]');
    var buybox = document.querySelector('[data-mns-buybox]');
    if (progressFill) {
      var startEl = document.querySelector('.mns-article');
      var endEl = buybox || startEl;
      var pScheduled = false;
      function updateProgress() {
        if (pScheduled) return;
        pScheduled = true;
        window.requestAnimationFrame(function () {
          pScheduled = false;
          try {
            if (!startEl) return;
            var vh = window.innerHeight || document.documentElement.clientHeight;
            var y = window.scrollY || window.pageYOffset || 0;
            var start = startEl.getBoundingClientRect().top + y;
            var end = endEl.getBoundingClientRect().bottom + y - vh;
            var pct = end > start ? (y - start) / (end - start) : 0;
            progressFill.style.width = (Math.max(0, Math.min(1, pct)) * 100).toFixed(1) + '%';
          } catch (e) { /* swallow */ }
        });
      }
      window.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    }

    /* 4. Buy box state machine ----------------------------------------- */
    if (buybox) initBuybox(buybox);

    /* 5. Inline / sticky CTA clicks: smooth-scroll + tracking ----------- */
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-mns-scroll]');
      if (!a) return;
      var placement = a.getAttribute('data-cta-placement') || 'inline';
      ga('cta_click_' + slug(placement), { event_label: placement, cta_position: placement });
      ga('inline_cta_click', { event_label: placement, cta_position: placement });
      var href = a.getAttribute('href') || '';
      if (href.charAt(0) === '#') {
        var target = document.getElementById(href.slice(1));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          if (history.replaceState) { history.replaceState(null, '', href); }
        }
      }
    });

    /* 6. Sticky bar + buy-box in-view ---------------------------------- */
    initSticky(buybox);
  }

  /* ------------------------------------------------------------------ */
  function initBuybox(root) {
    var typeBtns = root.querySelectorAll('[data-mns-type]');
    var opts = root.querySelectorAll('[data-mns-opt]');
    var perdayEl = root.querySelector('[data-mns-perday]');
    var benefitsEl = root.querySelector('[data-mns-benefits]');
    var finePrintEl = root.querySelector('[data-mns-fineprint]');
    var atc = root.querySelector('[data-mns-atc]');
    if (!opts.length || !atc) return;

    /* Default purchase type is subscribe unless the section opts into one-time
       via data-default-type="onetime" (render() below syncs the UI to it). */
    var initialType = root.getAttribute('data-default-type') === 'onetime' ? 'onetime' : 'subscribe';
    /* Default quantity comes from data-default-qty (section setting); falls back
       to the first option card when no card matches. */
    var initialQty = root.getAttribute('data-default-qty') || '1';
    var initialOpt = opts[0];
    for (var q = 0; q < opts.length; q++) {
      if (opts[q].getAttribute('data-qty') === initialQty) { initialOpt = opts[q]; break; }
    }
    var state = { type: initialType, opt: initialOpt };
    /* Gift card variant added alongside any 3-bag add (same rule as the
       gamified tier selector). Blank setting = no gift. */
    var giftVariantId = parseInt(root.getAttribute('data-gift-variant'), 10) || 0;

    function pfx() { return state.type === 'subscribe' ? 'sub' : 'one'; }

    function checkIcon() {
      return '<svg width="15" height="15" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 10.5l3.5 3.5L16 5.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }

    function render() {
      var p = pfx();
      /* toggle */
      for (var i = 0; i < typeBtns.length; i++) {
        typeBtns[i].setAttribute('aria-pressed', typeBtns[i].getAttribute('data-mns-type') === state.type ? 'true' : 'false');
      }
      /* option cards */
      for (var j = 0; j < opts.length; j++) {
        var o = opts[j];
        var active = o === state.opt;
        o.setAttribute('aria-checked', active ? 'true' : 'false');
        var d = o.dataset;
        var price = d[p + 'Price'] || '';
        var cadence = d[p + 'Cadence'] || '';
        var compare = d[p + 'Compare'] || '';
        var badge = d[p + 'Badge'] || '';
        var priceEl = o.querySelector('[data-mns-opt-price]');
        var metaEl = o.querySelector('[data-mns-opt-meta]');
        var badgeEl = o.querySelector('[data-mns-opt-badge]');
        if (priceEl) {
          priceEl.innerHTML = (compare ? '<s>' + compare + '</s>' : '') + price +
            (cadence ? '<span class="mns-opt__cad">' + cadence + '</span>' : '');
        }
        if (metaEl) { metaEl.textContent = state.type === 'subscribe' ? 'Subscription' : 'One-time'; }
        if (badgeEl) {
          badgeEl.textContent = badge;
          badgeEl.className = 'mns-opt__badge' + (state.type === 'subscribe' && d.qty === '3' && badge ? ' mns-opt__badge--best' : '');
        }
      }
      /* per-day + benefits from the active option */
      var ad = state.opt.dataset;
      if (perdayEl) { perdayEl.innerHTML = '<strong>' + (ad[p + 'Price'] || '') + (ad[p + 'Cadence'] || '') + '</strong> &middot; ' + (ad[p + 'Perday'] || ''); }
      if (benefitsEl) {
        var lines = [];
        if (state.type === 'subscribe') {
          lines.push(ad.subDelivery, root.getAttribute('data-sub-lock'), root.getAttribute('data-guarantee'));
        } else {
          lines.push(ad.oneDelivery, root.getAttribute('data-guarantee'));
        }
        var html = '';
        for (var k = 0; k < lines.length; k++) {
          if (lines[k]) { html += '<li>' + checkIcon() + '<span>' + lines[k] + '</span></li>'; }
        }
        benefitsEl.innerHTML = html;
      }
      /* Recurring-charge line under the button: subscribe states only. */
      if (finePrintEl) {
        if (state.type === 'subscribe') {
          var fpPrice = ad.subPrice || '';
          finePrintEl.textContent = 'Today ' + fpPrice + '. Then ' + fpPrice +
            (ad.qty === '3' ? ' every 3 months' : ' every month') + ' until you cancel.';
          finePrintEl.hidden = false;
        } else {
          finePrintEl.textContent = '';
          finePrintEl.hidden = true;
        }
      }
    }

    for (var t = 0; t < typeBtns.length; t++) {
      typeBtns[t].addEventListener('click', function () {
        state.type = this.getAttribute('data-mns-type');
        render();
      });
    }
    for (var m = 0; m < opts.length; m++) {
      opts[m].addEventListener('click', function () {
        state.opt = this;
        render();
      });
    }

    /* Add to cart */
    var busy = false;
    var defaultLabelEl = atc.querySelector('[data-mns-atc-label]');
    var defaultLabel = defaultLabelEl ? defaultLabelEl.textContent : atc.textContent;
    atc.addEventListener('click', function () {
      if (busy || atc.disabled) return;
      var variantId = parseInt(root.getAttribute('data-variant-id'), 10);
      if (!variantId) return;
      var d = state.opt.dataset;
      var p = pfx();
      var qty = parseInt(d.qty, 10) || 1;
      var plan = state.type === 'subscribe' ? parseInt(d.subPlan, 10) : 0;
      var value = d[p + 'Value'] || 0;
      var item = { id: variantId, quantity: qty };
      if (plan) { item.selling_plan = plan; }
      var items = [item];
      if (qty === 3 && giftVariantId) { items.push({ id: giftVariantId, quantity: 1 }); }

      busy = true;
      atc.disabled = true;
      if (defaultLabelEl) { defaultLabelEl.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          /* AddToCart with the selected state's value + currency */
          fb('AddToCart', { content_ids: cfg.contentIds, content_type: cfg.contentType, value: Number(value), currency: cfg.currency, num_items: qty });
          ga('add_to_cart', {
            event_label: 'buybox',
            cta_position: 'buybox',
            purchase_type: state.type,
            quantity: qty,
            selling_plan: plan || '',
            currency: cfg.currency,
            value: Number(value)
          });
          /* Let the theme's cart UI know (matches sticky-CTA.liquid) */
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'product-form-component', itemCount: qty } } }));
          if (defaultLabelEl) { defaultLabelEl.textContent = 'Added ✓'; }
          atc.classList.add('mns-cta-btn--success');
          var dest = root.getAttribute('data-redirect') || '/cart';
          window.setTimeout(function () { window.location.href = dest; }, 500);
        })
        .catch(function () {
          if (defaultLabelEl) { defaultLabelEl.textContent = 'Try again'; }
          atc.disabled = false;
          busy = false;
          window.setTimeout(function () { if (defaultLabelEl) { defaultLabelEl.textContent = defaultLabel; } }, 2000);
        });
    });

    render();
  }

  /* ------------------------------------------------------------------ */
  function initSticky(buybox) {
    var sticky = document.querySelector('[data-mns-sticky]');
    if (!sticky) return;
    var firstInline = document.querySelector('.mns-inline');
    var armed = !firstInline; /* if no inline card, arm immediately */
    var buyboxVisible = false;

    function update() {
      if (armed && !buyboxVisible) { sticky.classList.add('is-visible'); }
      else { sticky.classList.remove('is-visible'); }
    }

    if (typeof IntersectionObserver === 'function') {
      if (firstInline) {
        /* arm once the first inline CTA has scrolled out of the top */
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting && en.boundingClientRect.top < 0) { armed = true; }
            update();
          });
        }, { threshold: 0 }).observe(firstInline);
      }
      if (buybox) {
        var seenOffer = false;
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            buyboxVisible = en.isIntersecting;
            if (en.isIntersecting && !seenOffer) { seenOffer = true; ga('offer_view', { event_label: 'buybox' }); }
            update();
          });
        }, { threshold: 0.15 }).observe(buybox);
      }
    } else {
      armed = true;
      update();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
